module.exports = __webpack_public_path__ + "img/quick_coach_shuttle.c6d41f7f.webp";